var _path, _ellipse, _path2, _path3, _path4, _path5, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataPurpose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 43.4989V16.5456C56 15.4781 55.3983 14.4552 54.4264 13.9659L29.5273 0.400297C28.5554 -0.133432 27.3983 -0.133432 26.4727 0.400297L1.57355 13.9214C0.601653 14.4552 0 15.4337 0 16.5011V43.4989C0 44.5663 0.601653 45.5893 1.57355 46.0786L26.4727 59.5997C27.4446 60.1334 28.6017 60.1334 29.5273 59.5997L54.4264 46.0786C55.3983 45.5449 56 44.5663 56 43.4989Z",
    fill: "#EFF6FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0627,
    cy: 17.7734,
    rx: 1.40251,
    ry: 1.38091,
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7804 41.7261C15.282 42.2736 15.9509 42.5474 16.6756 42.5474H35.4044C36.1291 42.5474 36.7422 42.2736 37.2996 41.7261C37.8013 41.1785 38.08 40.5214 38.08 39.7001V19.8784C38.08 19.1118 37.8013 18.4547 37.2996 17.8524C36.798 17.3049 36.1291 17.0311 35.4044 17.0311H29.7746C29.4959 16.155 28.9943 15.4979 28.3254 14.9504C27.6565 14.4575 26.8761 14.1838 26.04 14.1838C25.2039 14.1838 24.4235 14.4575 23.7546 14.9504C23.0857 15.4432 22.5841 16.155 22.3054 17.0311H16.6756C15.9509 17.0311 15.3378 17.3049 14.7804 17.8524C14.2787 18.4 14 19.0571 14 19.8784V39.7001C14 40.4667 14.2787 41.1237 14.7804 41.7261Z",
    stroke: "#222222",
    strokeWidth: 2.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4097 21.586H16.9751C16.6652 21.586 16.4141 21.8333 16.4141 22.1383V23.2431C16.4141 23.5481 16.6652 23.7954 16.9751 23.7954H27.4097C27.7195 23.7954 27.9707 23.5481 27.9707 23.2431V22.1383C27.9707 21.8333 27.7195 21.586 27.4097 21.586Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8781 27.1086H16.9751C16.6652 27.1086 16.4141 27.3559 16.4141 27.661V28.7657C16.4141 29.0708 16.6652 29.3181 16.9751 29.3181H29.8781C30.188 29.3181 30.4391 29.0708 30.4391 28.7657V27.661C30.4391 27.3559 30.188 27.1086 29.8781 27.1086Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5851 32.6865H16.9751C16.6652 32.6865 16.4141 32.9338 16.4141 33.2388V34.3435C16.4141 34.6486 16.6652 34.8959 16.9751 34.8959H22.5851C22.8949 34.8959 23.1461 34.6486 23.1461 34.3435V33.2388C23.1461 32.9338 22.8949 32.6865 22.5851 32.6865Z",
    fill: "#222222"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.9968,
    cy: 40.8553,
    rx: 7.28,
    ry: 7.09091,
    fill: "#6484F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9997 38.1278C39.5469 38.1278 40.8001 39.3485 40.8001 40.8555C40.8001 42.3626 39.5469 43.5832 37.9997 43.5832C36.4524 43.5832 35.1992 42.3626 35.1992 40.8555C35.1992 39.3485 36.4524 38.1278 37.9997 38.1278ZM37.9997 38.8129C36.836 38.8129 35.9025 39.7346 35.9025 40.8555C35.9025 41.9765 36.8488 42.8982 37.9997 42.8982C39.1505 42.8982 40.0968 41.9765 40.0968 40.8555C40.0968 39.7346 39.1505 38.8129 37.9997 38.8129Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0002 36.0752C40.7111 36.0752 42.9106 38.2175 42.9106 40.858C42.9106 43.4985 40.7111 45.6408 38.0002 45.6408C35.2893 45.6408 33.0898 43.4985 33.0898 40.858C33.0898 38.2175 35.2893 36.0752 38.0002 36.0752ZM38.0002 36.7602C35.6729 36.7602 33.7931 38.5911 33.7931 40.858C33.7931 43.1248 35.6729 44.9557 38.0002 44.9557C40.3275 44.9557 42.2072 43.1248 42.2072 40.858C42.2072 38.5911 40.3275 36.7602 38.0002 36.7602Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8879 40.5206H32.7422V41.1932H35.8879V40.5206Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7437 41.1932C32.9344 41.1932 33.089 41.0426 33.089 40.8569C33.089 40.6711 32.9344 40.5206 32.7437 40.5206C32.553 40.5206 32.3984 40.6711 32.3984 40.8569C32.3984 41.0426 32.553 41.1932 32.7437 41.1932Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9019 41.1932C36.0937 41.1932 36.2472 41.0437 36.2472 40.8569C36.2472 40.67 36.0937 40.5206 35.9019 40.5206C35.7101 40.5206 35.5566 40.67 35.5566 40.8569C35.5566 41.0437 35.7101 41.1932 35.9019 41.1932Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3448 35.7377H37.6543V38.8017H38.3448V35.7377Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3448 35.7373C38.3448 35.9241 38.1914 36.0736 37.9996 36.0736C37.8077 36.0736 37.6543 35.9241 37.6543 35.7373C37.6543 35.5505 37.8077 35.401 37.9996 35.401C38.1914 35.401 38.3448 35.5505 38.3448 35.7373Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3448 38.8135C38.3448 39.0003 38.1914 39.1498 37.9996 39.1498C37.8077 39.1498 37.6543 39.0003 37.6543 38.8135C37.6543 38.6267 37.8077 38.4772 37.9996 38.4772C38.1914 38.4772 38.3448 38.6267 38.3448 38.8135Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2512 40.5206H40.1055V41.1932H43.2512V40.5206Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2535 41.1932C43.0617 41.1932 42.9082 41.0437 42.9082 40.8569C42.9082 40.67 43.0617 40.5206 43.2535 40.5206C43.4453 40.5206 43.5987 40.67 43.5987 40.8569C43.5987 41.0437 43.4453 41.1932 43.2535 41.1932Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.107 41.1932C39.9152 41.1932 39.7617 41.0437 39.7617 40.8569C39.7617 40.67 39.9152 40.5206 40.107 40.5206C40.2988 40.5206 40.4522 40.67 40.4522 40.8569C40.4522 41.0437 40.2988 41.1932 40.107 41.1932Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3448 42.9099H37.6543V45.9739H38.3448V42.9099Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9996 46.3124C38.1902 46.3124 38.3448 46.1618 38.3448 45.9761C38.3448 45.7904 38.1902 45.6398 37.9996 45.6398C37.8089 45.6398 37.6543 45.7904 37.6543 45.9761C37.6543 46.1618 37.8089 46.3124 37.9996 46.3124Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6543 42.9113C37.6543 42.7245 37.8077 42.5751 37.9996 42.5751C38.1914 42.5751 38.3448 42.7245 38.3448 42.9113C38.3448 43.0982 38.1914 43.2476 37.9996 43.2476C37.8077 43.2476 37.6543 43.0982 37.6543 42.9113Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0015 41.1936C38.1933 41.1936 38.3468 41.0442 38.3468 40.8573C38.3468 40.6705 38.1933 40.521 38.0015 40.521C37.8097 40.521 37.6562 40.6705 37.6562 40.8573C37.6562 41.0442 37.8097 41.1936 38.0015 41.1936Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPurpose);
export default __webpack_public_path__ + "static/media/data-purpose.ef4882d819b750f738bceb908981affd.svg";
export { ForwardRef as ReactComponent };